import { render } from "./tipsFour.vue?vue&type=template&id=d54397ee"
import script from "./tipsFour.vue?vue&type=script&lang=js"
export * from "./tipsFour.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__